export * from './types';
export { createGraphiQLFetcher } from './createFetcher';
//# sourceMappingURL=index.js.map